module.exports = __webpack_public_path__ + "static/media/Blender-4.b40c1c09.webp";